module.exports = __webpack_public_path__ + "static/media/IMG_7844.af16fae5.JPG";